import { IconSpriteComponent } from './icon-sprite.component';

export default angular
  .module('ng1-icon-sprite', [])
  .component('iconSprite', IconSpriteComponent)
  .name;
